export default "__VITE_ASSET__BzgIEkfc__"